import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "list-unstyled" }

import { computed } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from '@shell/composables/useI18n';
import CertManagerResourceTabs from '../components/CertManagerResourceTabs.vue';
import Tab from '@shell/components/Tabbed/Tab.vue';
import Banner from '@components/Banner/Banner.vue';
import DetailText from '@shell/components/DetailText.vue';
import ResourceTable from '@shell/components/ResourceTable.vue';
import DetailSummary, { SummaryItem } from '../components/DetailSummary.vue';
import { ORDER_HEADERS } from '../table-headers';
import { useRelatedTypes } from '../composables/useRelatedTypes';
import { CERT_MANAGER } from '../types';


export default /*@__PURE__*/_defineComponent({
  __name: 'cert-manager.io.certificaterequest',
  props: {
    value: {}
  },
  setup(__props: any) {

const props = __props;

// Related resources are read from the store; a directly loaded detail page has none yet. Gate the
// related-data parts of the template on `loaded` so they render against the populated store.
const { loaded } = useRelatedTypes([CERT_MANAGER.ORDER, CERT_MANAGER.CHALLENGE]);

const { t } = useI18n(useStore());

const csr = computed(() => props.value.csrInfo);

const csrSummary = computed<SummaryItem[]>(() => [
  { label: t('certManager.certificateRequest.subject'), value: csr.value?.subject },
  { label: t('certManager.certificateRequest.signatureAlgorithm'), value: csr.value?.signatureAlgorithm },
]);

const csrIdentifiers = computed(() => [
  { label: t('certManager.certificate.dnsNames'), values: csr.value?.dnsNames || [] },
  { label: t('certManager.certificate.ipAddresses'), values: csr.value?.ipAddresses || [] },
  { label: t('certManager.certificate.uris'), values: csr.value?.uris || [] },
  { label: t('certManager.certificate.emailAddresses'), values: csr.value?.emailAddresses || [] },
].filter((group) => group.values.length));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (__props.value.isDenied)
      ? (_openBlock(), _createBlock(Banner, {
          key: 0,
          color: "error",
          label: __props.value.deniedCondition?.message || _unref(t)('certManager.certificateRequest.denied')
        }, null, 8, ["label"]))
      : _createCommentVNode("", true),
    _cache[4] || (_cache[4] = _createTextVNode()),
    _createVNode(CertManagerResourceTabs, { value: __props.value }, {
      default: _withCtx(() => [
        _createVNode(Tab, {
          name: "csr",
          label: _unref(t)('certManager.certificateRequest.tab.csr'),
          weight: 30
        }, {
          default: _withCtx(() => [
            (!csr.value)
              ? (_openBlock(), _createBlock(Banner, {
                  key: 0,
                  color: "warning",
                  label: _unref(t)('certManager.certificateRequest.csrUnreadable')
                }, null, 8, ["label"]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(DetailSummary, { items: csrSummary.value }, null, 8, ["items"]),
                  _cache[1] || (_cache[1] = _createTextVNode()),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(csrIdentifiers.value, (group) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: group.label,
                      class: "mmb-5"
                    }, [
                      _createElementVNode("h3", null, _toDisplayString(group.label), 1),
                      _cache[0] || (_cache[0] = _createTextVNode()),
                      _createElementVNode("ul", _hoisted_1, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.values, (name) => {
                          return (_openBlock(), _createElementBlock("li", { key: name }, _toDisplayString(name), 1))
                        }), 128))
                      ])
                    ]))
                  }), 128)),
                  _cache[2] || (_cache[2] = _createTextVNode()),
                  _createVNode(DetailText, {
                    value: csr.value.pem,
                    "label-key": "certManager.certificateRequest.pem"
                  }, null, 8, ["value"])
                ], 64))
          ]),
          _: 1
        }, 8, ["label"]),
        _cache[3] || (_cache[3] = _createTextVNode()),
        _createVNode(Tab, {
          name: "orders",
          label: _unref(t)('certManager.certificateRequest.tab.orders'),
          weight: 20
        }, {
          default: _withCtx(() => [
            _createVNode(ResourceTable, {
              rows: _unref(loaded) ? __props.value.orders : [],
              headers: _unref(ORDER_HEADERS),
              "table-actions": false,
              groupable: false
            }, null, 8, ["rows", "headers"])
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _: 1
    }, 8, ["value"])
  ]))
}
}

})